import { Button } from '@bbl-digital/snorre-v2'

type Props = {} & React.ComponentProps<typeof Button>

const FileuploadPickerButton = (props: Props) => {
  return <>{<Button {...props}>Last opp fil</Button>}</>
}

export default FileuploadPickerButton
